/* eslint-disable global-require */
module.exports = {
    alive: require('./alive'),
    broadcastAlerts: require('./broadcastAlerts'),
    channels: require('./channels'),
    conditionHistory: require('./conditionHistory'),
    config: require('./config'),
    dataAlerts: require('./dataAlerts'),
    dataHistory: require('./dataHistory'),
    devices: require('./devices'),
    forgotPassword: require('./forgotPassword'),
    groups: require('./groups'),
    inProgressTriggered: require('./inProgressTriggered'),
    invitations: require('./invitations'),
    license: require('./license'),
    notificationHistory: require('./notificationHistory'),
    notificationResult: require('./notificationResult'),
    permissions: require('./permissions'),
    qrTokens: require('./qrTokens'),
    sources: require('./sources'),
    sourcesApps: require('./sourcesApps'),
    sourcesObjects: require('./sourcesObjects'),
    sourcesTasks: require('./sourcesTasks'),    
    systemAlerts: require('./systemAlerts'),
    systemHistory: require('./systemHistory'),
    userLicenses: require('./userLicenses'),
    users: require('./users'),
    dataHistoryNegativeValues: require('./dataHistoryNegativeValues'),
    dataHistoryPositiveValues: require('./dataHistoryPositiveValues')
}